/**
 * Constants for HttpNode
 * Uses enums from types/enums.ts (auto-generated from Laravel)
 */

import { HttpConvertType, HttpNotSendType, RequestConnectionPropertyType } from "types/enums";

export const HTTP_METHOD_OPTIONS = [
    { value: "GET", labelKey: "nodes.http.forms.method_options.get" },
    { value: "POST", labelKey: "nodes.http.forms.method_options.post" },
    { value: "PUT", labelKey: "nodes.http.forms.method_options.put" },
    { value: "PATCH", labelKey: "nodes.http.forms.method_options.patch" },
    { value: "DELETE", labelKey: "nodes.http.forms.method_options.delete" },
] as const;

// Format options - BE values sent directly
export const HTTP_FORMAT_OPTIONS = [
    { value: "application/json", labelKey: "nodes.http.forms.format_options.json" },
    { value: "multipart/form-data", labelKey: "nodes.http.forms.format_options.multipart_form_data" },
    { value: "application/x-www-form-urlencoded", labelKey: "nodes.http.forms.format_options.x_www_form_urlencoded" },
    {
        value: "x-www-form-urlencoded+json-data",
        labelKey: "nodes.http.forms.format_options.x_www_form_urlencoded_json",
    },
    { value: "login-data-pass", labelKey: "nodes.http.forms.format_options.login_data_pass" },
] as const;

// Response format (parser) options - "plain" means null to BE
export const HTTP_PARSER_OPTIONS = [
    { value: "json", labelKey: "nodes.http.forms.parser_options.json" },
    { value: "xml", labelKey: "nodes.http.forms.parser_options.xml" },
    { value: "plain", labelKey: "nodes.http.forms.parser_options.plain" },
] as const;

export const HTTP_SOURCE_TYPE_OPTIONS = [
    { value: RequestConnectionPropertyType.Constant, labelKey: "nodes.http.forms.source_options.constant" },
    { value: RequestConnectionPropertyType.Object, labelKey: "nodes.http.forms.source_options.object" },
    { value: RequestConnectionPropertyType.Combine, labelKey: "nodes.http.forms.source_options.combine" },
    { value: RequestConnectionPropertyType.Md5, labelKey: "nodes.http.forms.source_options.md5" },
] as const;

// Blank values - don't send options
export const HTTP_NOTSEND_OPTIONS = [
    { value: HttpNotSendType.NULL, labelKey: "nodes.http.forms.notsend_options.null" },
    { value: HttpNotSendType.EMPTY_STRING, labelKey: "nodes.http.forms.notsend_options.empty_string" },
    { value: HttpNotSendType.NONEXIST, labelKey: "nodes.http.forms.notsend_options.nonexist" },
    { value: HttpNotSendType.NULL_EMPTY_STRING, labelKey: "nodes.http.forms.notsend_options.null_empty_string" },
    {
        value: HttpNotSendType.NONEXIST_EMPTY_STRING,
        labelKey: "nodes.http.forms.notsend_options.nonexist_empty_string",
    },
    { value: HttpNotSendType.NULL_NONEXIST, labelKey: "nodes.http.forms.notsend_options.null_nonexist" },
    {
        value: HttpNotSendType.NULL_NONEXIST_EMPTY_STRING,
        labelKey: "nodes.http.forms.notsend_options.null_nonexist_empty_string",
    },
] as const;

// Blank values - convert options
export const HTTP_CONVERT_DATA_OPTIONS = [
    {
        value: HttpConvertType.EMPTY_STRING_TO_NULL,
        labelKey: "nodes.http.forms.convert_data_options.empty_string_to_null",
    },
    {
        value: HttpConvertType.NULL_TO_EMPTY_STRING,
        labelKey: "nodes.http.forms.convert_data_options.null_to_empty_string",
    },
    { value: HttpConvertType.NONEXIST_TO_NULL, labelKey: "nodes.http.forms.convert_data_options.nonexist_to_null" },
    {
        value: HttpConvertType.NONEXIST_TO_EMPTY_STRING,
        labelKey: "nodes.http.forms.convert_data_options.nonexist_to_empty_string",
    },
    {
        value: HttpConvertType.EMPTY_STRING_NONEXIST_TO_NULL,
        labelKey: "nodes.http.forms.convert_data_options.empty_string_nonexist_to_null",
    },
    {
        value: HttpConvertType.NULL_NONEXIST_TO_EMPTY_STRING,
        labelKey: "nodes.http.forms.convert_data_options.null_nonexist_to_empty_string",
    },
] as const;

// Signature type options - base types, combined with position (MD5) or sha (HMAC/DIGEST) to form BE value
// MD5 types - use position (prefix/suffix)
// HMAC/DIGEST types - use sha (256/512)
export const HTTP_SIGNATURE_TYPE_OPTIONS: readonly {
    value: string;
    labelKey: string;
    hasPosition?: boolean;
    hasSha?: boolean;
}[] = [
    // MD5 variants - will combine with position
    { value: "md5_values", labelKey: "nodes.http.forms.signature_type_options.md5_values", hasPosition: true },
    {
        value: "md5_sorted_values",
        labelKey: "nodes.http.forms.signature_type_options.md5_sorted_values",
        hasPosition: true,
    },
    { value: "md5_keyval", labelKey: "nodes.http.forms.signature_type_options.md5_keyval", hasPosition: true },
    {
        value: "md5_sorted_keyval",
        labelKey: "nodes.http.forms.signature_type_options.md5_sorted_keyval",
        hasPosition: true,
    },
    // HMAC/DIGEST variants - will combine with sha
    { value: "hmac_body", labelKey: "nodes.http.forms.signature_type_options.hmac_body", hasSha: true },
    {
        value: "hmac_timestamp_body",
        labelKey: "nodes.http.forms.signature_type_options.hmac_timestamp_body",
        hasSha: true,
    },
    {
        value: "hmac_timestamp_json",
        labelKey: "nodes.http.forms.signature_type_options.hmac_timestamp_json",
        hasSha: true,
    },
    {
        value: "hmac_rfc7231_body",
        labelKey: "nodes.http.forms.signature_type_options.hmac_rfc7231_body",
        hasSha: true,
    },
    {
        value: "hmac_sorted_keyval",
        labelKey: "nodes.http.forms.signature_type_options.hmac_sorted_keyval",
        hasSha: true,
    },
    { value: "digest_base64", labelKey: "nodes.http.forms.signature_type_options.digest_base64", hasSha: true },
    { value: "digest_keyid_hmac", labelKey: "nodes.http.forms.signature_type_options.digest_keyid_hmac", hasSha: true },
    {
        value: "hmac_qsorted_keyval_nonce_bodyhash",
        labelKey: "nodes.http.forms.signature_type_options.hmac_qsorted_keyval_nonce_bodyhash",
        hasSha: true,
    },
];

export const HTTP_SIGNATURE_SHA_OPTIONS = [
    { value: "256", labelKey: "nodes.http.forms.signature_sha_options.256" },
    { value: "512", labelKey: "nodes.http.forms.signature_sha_options.512" },
] as const;

export const HTTP_SIGNATURE_POSITION_OPTIONS = [
    { value: "prefix", labelKey: "nodes.http.forms.signature_position_options.prefix" },
    { value: "suffix", labelKey: "nodes.http.forms.signature_position_options.suffix" },
] as const;

// Delimiter options - using BE HttpSignatureDataDelimiterType enum values
export const HTTP_DELIMITER_OPTIONS = [
    { value: "|", labelKey: "nodes.http.forms.delimiter_options.pipe" },
    { value: "&", labelKey: "nodes.http.forms.delimiter_options.ampersand" },
    { value: ".", labelKey: "nodes.http.forms.delimiter_options.dot" },
] as const;
